import React from 'react'
import { NavLink } from 'react-router-dom'
import { images } from '../../config/image';
import strings from '../Language';

const HeaderPublic = () => {
    return (
        <nav className="landing-nav hide-nav">
            <input type="checkbox" id="check" />
            <label htmlFor="check" className="checkbtn">
                <i className="fas fa-bars"></i>
            </label>

            <NavLink style={{ cursor: "pointer" }} to={"/"} className="landing-logo">
                <img src={images['logo']} alt="CTS Bot" />
            </NavLink>
            <ul>
                <li><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={"/"}>{strings.Home}</NavLink></li>
                <li><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={"/register"}>{strings.register}</NavLink></li>
                <li><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={"/login"}>{strings.member_login}</NavLink></li>
                <li className='profront-nav-cta-wrap'>
                    <NavLink className='profront-nav-cta' to={"/register"}>{strings.GET_STARTED_NOW}</NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default HeaderPublic
